// src/hooks/usePermissions.ts
import { useAuth } from '../contexts/AuthContext';

export function usePermissions() {
  const { permissions, loading, hasPermission } = useAuth();

  const hasAnyPermission = (permissionCodes: string[]): boolean => {
    return permissionCodes.some(code => hasPermission(code));
  };

  return {
    permissions,
    loading,
    hasPermission,
    hasAnyPermission
  };
}